/**
 * 功能: 数据比对异常信息的弹框、对异常数据进行修复
 */

<template lang="pug">
  el-dialog.comparison(title="异常信息" :visible.sync="isShow" width="800px" @close="handleClose" :close-on-press-escape="false" :close-on-click-modal="false" :show-close="false")
    el-table(:data="info" stripe style="width: 100%" v-loading="loading")
      el-table-column(prop="name" label="类型" width="100")
      el-table-column(prop="error" label="错误数量" width="100")
      el-table-column(prop="id" label="错误id" width="220" show-overflow-tooltip)
      el-table-column(prop="message" label="数据比对结果" width="120")
    span(slot='footer' class='dialog-footer')
      el-row(type="flex" justify="end")
        el-col(:span="24" v-if="syncTotal = -1")
          el-col(:span="3")
            span 修复进度
          el-col(:span="15")
            el-progress(:text-inside="true" :stroke-width="15" :percentage="percentage")
          el-col(:span="5")
            el-button(type="primary" :size="GLOBAL.SIZE_OF_INPUTBOX"  @click="handleClose" :disabled="iCantRepair" style="margin-right: 10px") 关闭
            el-button(type="primary" :size="GLOBAL.SIZE_OF_INPUTBOX"  @click="sync(0, 0)" :disabled="iCantRepair") 修复
</template>

<script>
import apis from '@/apis/export'
export default {
  name: 'abnormalDialog',
  data () {
    return {
      info: [
        { name: '报告', type: 'brief', error: 0, id: [], message: '' },
        { name: '名词解释', type: 'glossary', error: 0, id: [], message: '' },
        { name: '章节目录', type: 'outline', error: 0, id: [], message: '' },
        { name: '段落', type: 'section', error: 0, id: [], message: '' },
        { name: '幻灯片', type: 'slide', error: 0, id: [], message: '' },
        { name: '元素', type: 'element', error: 0, id: [], message: '' },
        { name: '数说', type: 'sizepro', error: 0, id: [], message: '' },
        { name: '图说', type: 'ill', error: 0, id: [], message: '' },
        { name: '专家说', type: 'quote', error: 0, id: [], message: '' },
        { name: '表说', type: 'table', error: 0, id: [], message: '' },
        { name: '文章', type: 'article', error: 0, id: [], message: '' },
        { name: '解说', type: 'video', error: 0, id: [], message: '' },
        { name: '个人', type: 'individual', error: 0, id: [], message: '' },
        { name: '团队', type: 'team', error: 0, id: [], message: '' },
        { name: '更新日志', type: 'updateLog', error: 0, id: [], message: '' }
      ],
      syncing: false,
      syncTotal: -1,
      divide: [],
      percentage: 0,
      isShow: false,
      loading: false,

      errorIds: { },
      iCantRepair: false
    }
  },
  watch: {
    total: 'disableButton'
  },
  methods: {
    // 关闭全局对比对话框
    handleClose () {
      this.info.map(item => { item.error = 0; item.id = []; item.message = '' })
      this.isShow = false
      this.percentage = 0
      this.errorIds = { }
    },
    // 执行比对过程
    getAbnormalData (currentProcess = 0, index = 0) {
      this.isShow = true
      this.loading = true
      this.iCantRepair = true
      const { type } = this.info[currentProcess]
      apis.getAbnormalData({ type, index }).then(res => {
        if (res.errCode === 0) {
          const { errorIds, index } = res.data
          if (Array.isArray(errorIds)) {
            this.errorIds[type] = Array.isArray(this.errorIds[type]) ? this.errorIds[type].concat(errorIds) : errorIds
          }
          if (index !== 0) {
            this.getAbnormalData(currentProcess, index)
            return true
          } else {
            this.info[currentProcess].error = this.errorIds[type].length || 0
            this.info[currentProcess].id = this.errorIds[type].map(item => item + ', ')
            this.info[currentProcess].message = '对比成功'
          }
        } else {
          this.info[currentProcess].message = res.msg
        }
        currentProcess++
        if (currentProcess < this.info.length) {
          setTimeout(() => {
            this.getAbnormalData(currentProcess)
          }, 500)
        } else {
          this.iCantRepair = false
        }
        this.loading = false
      }).catch(err => {
        this.$message({ message: err, type: 'error' })
      })
    },
    // 对异常数据执行同步过程
    async sync (currentProcess = 0, index = 0) {
      this.loading = true
      if (!this.syncing) {
        const { type } = this.info[currentProcess] || { }
        const result = await apis.fixData({ type, index })
        if (result.errCode === 0) {
          const { index } = result.data
          if (index !== 0) { // 继续同步当前的
            this.sync(currentProcess, index)
            return true
          }
          if (currentProcess >= this.info.length) {
            this.syncing = true
            this.syncTotal = result.data.total
            this.divide = result.data.divide
            this.total = result.data.total
          }
          currentProcess = currentProcess + 1
          setTimeout(async () => {
            await this.sync(currentProcess, index)
          }, 500)
        } else {
          this.$message({ type: 'error', message: '生成数据缓存失败！' })
        }
      } else {
        if (this.syncTotal > 0) {
          const result = await apis.syncData([this.divide[0], this.divide[1]])
          if (result.errCode === 0) {
            this.syncTotal = result.data
            this.percentage = Math.round(((this.total - this.syncTotal) / this.total) * 100)
            this.divide.shift()
            this.sync()
          } else {
            this.syncing = false
            this.$message({ type: 'error', message: result.msg || '修复失败' })
          }
        } else {
          this.syncTotal = 0
          this.info.forEach(item => { item.error = 0; item.id = [] })
          this.syncing = false
          this.errorIds = {}
          this.percentage = 100
          this.loading = false
          this.$message({ type: 'success', message: '修复成功！' })
        }
      }
    }
  }
}
</script>

<style>
.comparison table{
  width: 100% !important;
  zoom: 0.9;
}
.comparison .el-dialog__body {
  padding: 10px 15px;
}
</style>
